import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18next'
import { dateLocales } from 'locales'
import dayjs from 'dayjs'

function useLocale() {
    const locale = useSelector((state) => state.locale.currentLang)

    useEffect(() => {
        if (!locale) {
            return
        }
        const formattedLang = locale.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase()
        })
        if (locale !== i18n.language) {
            i18n.changeLanguage(formattedLang)
        }
        const dateLocaleLoader = dateLocales[formattedLang]
        if (dateLocaleLoader && typeof dateLocaleLoader === 'function') {
            dateLocaleLoader().then(() => {
                dayjs.locale(formattedLang)
            }).catch(() => {
                // Fallback to default locale if import fails
                dayjs.locale('en')
            })
        } else {
            // Fallback to default locale if locale not found
            dayjs.locale('en')
        }
    }, [locale])

    return locale
}

export default useLocale
